import React from 'react';
import {ColorSwatch} from '@customink/pigment-react';
import {Rgb} from '../../models/product';
import {rgbToHex} from '../../utils/helpers';
import './index.scss';

type ProductColorSwatchProps = {
  rgb: Rgb;
  productId: number | null;
  trimRgb: Rgb | null;
  colorName: string | null;
  displayOnly?: boolean;
  colorId: number | null;
  handleSelect: (productId: number, colorId: number) => void | null;
};

const ProductColorSwatch: React.FC<ProductColorSwatchProps> = ({
  rgb,
  trimRgb,
  colorName,
  colorId,
  displayOnly,
  productId,
  handleSelect
}: ProductColorSwatchProps) => {
  return (
    <ColorSwatch
      className="productColorSwatch"
      size="small"
      displayOnly={displayOnly}
      color={rgbToHex(rgb)}
      trimRgb={trimRgb && rgbToHex(trimRgb)}
      aria-label={colorName}
      onClick={
        handleSelect
          ? () => handleSelect(productId, colorId)
          : () => {
              /* nothing */
            }
      }
    />
  );
};

export default ProductColorSwatch;

ProductColorSwatch.defaultProps = {
  displayOnly: false
};
